export default {
  contracts: {
    activeContracts: 'Platné smlouvy',
    productsAndHours: 'Podporované produkty a zůstatky k čerpání',
    supported: 'Podporováno',
    notSupported: 'Nepodporováno',
    contact: 'Manager'
  },
  states: {
    OPEN: 'Otevřené',
    AWAITING_REPLY: 'Čekající na odpověď',
    CLOSED: 'Uzavřené',
    FEEDBACK_REQUIRED: 'Požadována zpětná vazba',
    onlyRequired: 'Zobraz pouze vyžadující mou reakci',
    onlyWorkRequests: 'Zobrazit pouze Schválení požadavků na práci'
  },
  common: {
    New: 'Nový',
    Open: 'Otevřený',
    Pending: 'Čekající',
    Closed: 'Uzavřený',
    create: 'Vytvořit',
    cancel: 'Zrušit',
    goBack: 'Zpět',
    close: 'Zavřít',
    goToMain: 'Zpět na hlavní stránku'
  },
  property: {
    name: 'Provozovna',
    allProperties: 'Všechny provozovny',
    selectProperty: 'Vybrat provozovnu'
  },
  product: {
    name: 'Produkt',
    allProducts: 'Všechny produkty',
    selectProduct: 'Vybrat produkt',
    goBack: 'Zpět',
    noProducts: 'Bez produktu'
  },
  chart: {
    chooseMonth: 'Vybrat měsíc',
    noData: 'Data pro zvolené období neexistují'
  },
  navigation: {
    main: 'HLAVNÍ',
    interactions: 'POŽADAVKY',
    contracts: 'SMLOUVY',
    signOut: 'ODHLÁSIT SE'
  },
  tickets: {
    createNewTitle: 'Vytvořit nový požadavek',
    title: 'Název',
    noTickets: 'Nastaveným filtrům nevyhovuje žádný požadavek',
    search: 'Hledat',
    createNew: 'Vytvořit nový',
    reopenOrDisagree: 'Nesouhlasit s uzavřením',
    escalation: 'Eskalovat',
    reason: 'Důvod',
    reopen: 'Nesouhlasit',
    escalate: 'Eskalovat',
    opinionTitle: 'Vážíme si Vašeho názoru na naše služby!',
    opinionBody: 'Prosíme o hodnocení práce našich zaměstnanců',
    time: 'Doba potřebná pro vyřešení',
    qualification: 'Odborná kvalifikace',
    communication: 'Komunikační dovednosti',
    sendFeedback: 'Odeslat hodnocení',
    leaveFeedback: 'Ohodnonit',
    close: 'Zavřít',
    alreadyHasFeedback: 'Tento požadavek byl již hodnocen',
    feedbackHasBeenSent: 'Hodnocení bylo uloženo',
    ticketHasBeenReopened: 'Požadavek byl znovu otevřen',
    ticketHasBeenEscalated: 'Požadavek byl eskalován',
    comment: 'Komenátář',
    keyPlaceholder: 'Napište zprávu',
    approve: 'Schvalovat',
    reject: 'Odmítnout',
    workRequestOnContractNotification:
      'Vážený {{fullName}},\\n\\nV současné době máte {{hoursInSupportContract}} hodin služeb s přidanou hodnotou (VAS value-added services), které jsou zahrnuté ve vaší smlouvě o podpoře.\\n Dokončení požadavku {{workRequestId}} bude vyžadovat {{hoursRequested}} hodin. \\n\\nProsím Vás o schválení odečtení hodin ze zůstatku dle výše uvedeného požadavku.\\nDěkuji.\\n\\nS pozdravem\\n{{author}}',
    workRequestChargeableNotification:
      'Vážený {{fullName}},\\n\\nTato práce není součástí služeb ani není zaručena podle smlouvy o podpoře. Rádi jí naplánujeme a pomůžeme Vám s jejím řešením. Odhadujeme {{hoursRequested}} hodin na dokončení požadavku {{workRequestId}}.\\n\\nCena za dokončení tohoto požadavku bude {{amount}}.\\nTato nabídka je platná do 7 dnů od data vystavení. \\nPokud skutečně strávený čas překročí původní cenovou nabídku, bude žadateli zaslán dodatečný formulář se žádostí o další hodiny ke schválení. Pokud bude odhadovaný čas kratší než původní nabídka, původní nabídka bude zrušena a následně bude odeslána nabídka s pouze skutečným množstvím potřebných hodin.\\n\\nProsím Vás tedy o schválení požadované vícepráce a její zpoplatnění.\\n\\nS pozdravem\\n{{autor}}',
    workRequestCommentRequired: 'Uveďte prosím důvod zamítnutí žádosti o práci.'
  },
  severity: {
    name: 'Důležitost',
    0: 'Normální',
    1: 'Vysoká',
    2: 'Kritická'
  },
  forms: {
    password: 'Heslo',
    confirmPassword: 'Heslo znovu pro kontrolu',
    passwordsDoNotMatch: 'Zadaná hesla se neshodují',
    updatePassword: 'Změnit heslo',
    askRestore: 'Vyžádat změnu hesla',
    remember: 'Zapamatovat',
    restorePassword: 'Obnovit heslo',
    signIn: 'Přihlásit'
  },
  transactions: {
    date: 'Datum',
    type: 'Typ',
    comment: 'Komenátář',
    status: 'Status',
    subject: 'Požadavek na čerpání služeb',
    name: 'Přehled čerpání služeb',
    hours: 'Hodiny',
    viewTransactions: 'Přehled čerpání služeb',
    types: {
      WORK_REQUEST: 'Požadavek na čerpání služeb',
      CONTRACT_ACTIVATION: 'Aktivace smlouvy - Od',
      CONTRACT_EXPIRATION: 'Platnost smlouvy - Do',
      MANUAL_ADJUST_ADD: 'Manuální změna - Navýšit',
      MANUAL_ADJUST_DEDUCT: 'Manuální změna - Ponížit',
      TRANSFER_PROPERTY: 'Převést na jinou provozovnu',
      TRANSFER_PRODUCT: 'Převést na jiný produkt'
    }
  },
  transactionDetail: {
    name: 'Detail čerpání služeb',
    num: 'Číslo',
    insertTime: 'Datum vytvoření',
    requestorName: 'Jméno žadatele',
    subject: 'Předmět',
    status: 'Status',
    acceptTime: 'Datum přijetí',
    cancelTime: 'Datum zrušení',
    hours: 'Hodiny',
    hourType: 'Typ hodin',
    workText: 'Popis práce',
    plannedDate: 'Plánované datum'
  },
  statuses: {
    Approved: 'Potvrzeno',
    Pending: 'Čekající',
    Cancelled: 'Zrušeno'
  },
  hoursTypes: {
    'Included in contract': 'Hodiny zahrnuté ve smlouvě',
    'Installation hours': 'Hodiny pro instalace',
    'Preventative visit': 'Preventivní návštěva',
    Chargeable: 'Zpoplatněno'
  },
  errors: {
    unknown: 'Neznámá chyba',
    1000: 'Chyba v požadavku',
    1001: 'Chyba v požadavku',
    1: 'Nesprávné jméno nebo heslo',
    2: 'Relace vypršela',
    3: 'Neznámá provozovna',
    4: 'Neznámý produkt',
    7: 'Nenámý požadavek',
    8: 'Požadavek je již uzavřen',
    11: 'Přístup není povolen',
    12: 'Neznámý požadavek na čerpání služeb'
  }
}
